import { config } from "../../config"

export const PreviewExcelFile: React.FC<{ filePath: string }> = ({
  filePath,
}) => {
  return (
    <iframe
      title="excel-file-view"
      src={`${config.assets.docPreviewUrl}${config.assets.s3BaseUrl}/${filePath}`}
      style={{ width: "100%", height: "auto", minHeight: "90vh" }}
    />
  );
};
